// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"157":"1d8458f8","230":"e15eff56","270":"d3116ae1","436":"299a7a2e","495":"f3767143","593":"5b4b3f12","631":"67bd41cb","720":"a9aad703","877":"e5badfff"}[chunkId] + ".chunk.js";
};